import Button from "@app/components/button";
import GradientContainer from "@app/components/gradient/gradient-container";
import TextGradient from "@app/components/gradient/gradient-text";
import { useState } from "react";

/* eslint-disable @next/next/no-img-element */
const DesktopHealthcare = ({ inView5 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="pt-32 flex justify-center items-center">
      <div>
        <img
          src="/images/industries/healthcare.png"
          alt="healthcare"
        />
      </div>
      <div
        className={`shadow-lg-light absolute bg-opacity-80 bg-light blur-content 
          w-[95%] xl:w-[80%] rounded-2xl p-6`}
        style={{
          visibility: inView5 ? 'visible' : 'hidden',
          opacity: inView5 ? 0.9 : 0,
          transition: 'opacity 500ms ease-in',
        }}
      >
        <div
          className={`flex flex-col ml-2 space-y-5 
          ${isExpanded ? 'h-[515px] xl:h-[550px] 2xl:h-[520px]' : 'h-[380px] xl:h-[370px] 2xl:h-[340px]'}
           transition-[height] ease-out duration-500`}
        >
          <TextGradient>
            <p className="h2">05</p>
          </TextGradient>
          <p className="h3 text-background-primary-dark">Healthcare</p>
          <div>
            <GradientContainer overrideClassName="w-[22%] h-2" />
          </div>
          <div className=" text-text-color-mid-em-light space-y-5">
            <p>
              SimpleWaste represents all healthcare facility types with emphasis on the specialized
              management of all healthcare-unique waste profiles.
            </p>
            <p className=" xl:block">
              Our service model and technology platform provides cost reduction with 100% transparency.
              We&apos;ve designed our platform to benefit single units, multiple locations,
              and IDNs, with 24/7 access to live data, billing, and compliance reports.
            </p>
            {isExpanded && (
              <div className="space-y-5">
                <p>
                  SimpleWaste&apos;s unique technology platform provides key functionality to support your specialized waste and recycling programs.
                  Our Sole Source User Interface provides unlimited integration across
                  multiple facility types and operations for detailed waste profile
                  management and connected workflow.
                </p>
                <p>
                  We keep your operations team up to speed with KPI and data metrics
                  specific to the healthcare industry.
                </p>
                <p className="hidden xl:block">
                  At SimpleWaste we design effective solutions that flow seamlessly
                  within your operational footprint.
                </p>
              </div>
            )}
          </div>
          <div className="flex h-full items-end">
            <div>
              <Button onClick={() => setIsExpanded(!isExpanded)}>
                {isExpanded ? 'Read less' : 'Read more'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default DesktopHealthcare
